module.exports = __webpack_public_path__ + "static/media/sample_report.f1d300a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sample_report.png
// module id = 386
// module chunks = 17